exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sound-editor-modal_modal_1c0DN {\n    width: 74.88rem;\n}\n", ""]);

// exports
exports.locals = {
	"modal": "sound-editor-modal_modal_1c0DN"
};